// ── OTT PLATFORM DEFINITIONS ──────────────────────────────────
// Each platform has: id, name, color, bgColor, and an SVG logo path

export const OTT_PLATFORMS = [
  {
    id: 'netflix',
    name: 'Netflix',
    color: '#E50914',
    bgColor: '#141414',
    logo: `<svg viewBox="0 0 24 24" fill="#E50914" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.398 0v.006c3.028 8.556 5.37 15.175 8.348 23.596 2.344.058 4.85.398 4.854.398-2.8-7.924-5.923-16.747-8.487-24zm8.489 0v9.63L18.6 24c-.538.086-2.885.285-4.587.332L9.387 14.233v10.02c-1.609.048-2.468.043-3.978.013V0zm-8.489 0H1.6v24c1.557-.07 2.716-.108 3.798-.17V0z"/>
    </svg>`,
  },
  {
    id: 'prime',
    name: 'Prime Video',
    color: '#00A8E1',
    bgColor: '#0F171E',
    logo: `<svg viewBox="0 0 24 24" fill="#00A8E1" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.127 9.368c0 .888-.024 1.639-.072 2.256-.048.594-.168 1.092-.36 1.476-.192.384-.48.672-.864.864-.384.168-.888.264-1.512.264H8.832V6.504h1.488c.624 0 1.128.096 1.512.264.384.192.672.48.864.864.192.384.312.876.36 1.476.048.594.072 1.356.072 2.26zm1.668 0c0-1.02-.084-1.884-.252-2.592-.168-.732-.444-1.332-.828-1.8-.384-.492-.888-.852-1.512-1.092-.624-.264-1.38-.396-2.268-.396H7.164V15h3.768c.888 0 1.644-.132 2.268-.396.624-.24 1.128-.6 1.512-1.092.384-.468.66-1.068.828-1.8.168-.708.252-1.572.252-2.592V9.37zm-6.663-3.78h2.052c.516 0 .936.072 1.26.216.324.144.576.348.756.612.18.264.3.576.36.936.072.36.108.756.108 1.188v.828c0 .432-.036.828-.108 1.188-.06.36-.18.672-.36.936-.18.264-.432.468-.756.612-.324.144-.744.216-1.26.216H8.132V5.588zM3.6 18.048c3.984 2.304 8.376 3.624 13.032 3.624 2.232 0 4.392-.348 6.408-1.008l.36-1.38c-2.064.708-4.284 1.08-6.576 1.08-4.464 0-8.652-1.284-12.144-3.504l-1.08 1.188z"/>
    </svg>`,
  },
  {
    id: 'hotstar',
    name: 'Disney+ Hotstar',
    color: '#1F80E0',
    bgColor: '#0C1B33',
    logo: `<svg viewBox="0 0 24 24" fill="#1F80E0" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L9.5 8.5H3l5.5 4-2 6.5L12 15l5.5 3.5-2-6.5L21 8.5h-6.5L12 2z"/>
    </svg>`,
  },
  {
    id: 'appletv',
    name: 'Apple TV+',
    color: '#ffffff',
    bgColor: '#000000',
    logo: `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.54 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/>
    </svg>`,
  },
  {
    id: 'hbo',
    name: 'HBO Max',
    color: '#A855F7',
    bgColor: '#0D0D1E',
    logo: `<svg viewBox="0 0 24 24" fill="#A855F7" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 5v14h3v-6h3v6h3V5h-3v5H6V5H3zm10 0v14h5.5C20.4 19 22 17.4 22 15.5c0-1.2-.6-2.2-1.5-2.8.6-.6 1-1.4 1-2.2C21.5 8.6 20.4 7 18.5 7H15V5h-2zm2 4h3c.8 0 1.5.7 1.5 1.5S18.8 12 18 12h-3V9zm0 5h3.5c.8 0 1.5.7 1.5 1.5S19.3 17 18.5 17H15v-3z"/>
    </svg>`,
  },
  {
    id: 'hulu',
    name: 'Hulu',
    color: '#1CE783',
    bgColor: '#0B2A1A',
    logo: `<svg viewBox="0 0 24 24" fill="#1CE783" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v3h2V8h2v8h-2v-3h-2v3z"/>
    </svg>`,
  },
  {
    id: 'zee5',
    name: 'ZEE5',
    color: '#8B5CF6',
    bgColor: '#1A0A2E',
    logo: `<svg viewBox="0 0 24 24" fill="#8B5CF6" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 6h16v2L8 16h12v2H4v-2l12-8H4V6z"/>
    </svg>`,
  },
  {
    id: 'sonyliv',
    name: 'SonyLIV',
    color: '#FF6B35',
    bgColor: '#1A0D08',
    logo: `<svg viewBox="0 0 24 24" fill="#FF6B35" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l7 4.5-7 4.5z"/>
    </svg>`,
  },
  {
    id: 'mubi',
    name: 'MUBI',
    color: '#FF3154',
    bgColor: '#0D0D0D',
    logo: `<svg viewBox="0 0 24 24" fill="#FF3154" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="12" r="4"/><circle cx="16" cy="12" r="4"/>
    </svg>`,
  },
  {
    id: 'jiocinema',
    name: 'JioCinema',
    color: '#8B5CF6',
    bgColor: '#0F0320',
    logo: `<svg viewBox="0 0 24 24" fill="#8B5CF6" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h12zm-5 5l-5 4 5 4V8z"/>
    </svg>`,
  },
  {
    id: 'aha',
    name: 'aha',
    color: '#F9001E',
    bgColor: '#1A0005',
    logo: `<svg viewBox="0 0 24 24" fill="#F9001E" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 3L4 20h3.5l1.5-3.5h6L16.5 20H20L12 3zm0 5.5l2 5h-4l2-5z"/>
    </svg>`,
  },
  {
    id: 'youtube',
    name: 'YouTube',
    color: '#FF0000',
    bgColor: '#0F0F0F',
    logo: `<svg viewBox="0 0 24 24" fill="#FF0000" xmlns="http://www.w3.org/2000/svg">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>`,
  },
  {
    id: 'other',
    name: 'Other',
    color: '#888888',
    bgColor: '#1a1a1a',
    logo: `<svg viewBox="0 0 24 24" fill="#888" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 6h16v12H4V6zm2 2v8h12V8H6zm2 2h8v4H8v-4z"/>
    </svg>`,
  },
];

export const getOTT = (id) => OTT_PLATFORMS.find(p => p.id === id);
